// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.urlLink[data-v-d1d505c8] {\r\n    font-size: .8em;\r\n    font-weight: bold;\r\n    color: black;\n}\n.pointer[data-v-d1d505c8] {\r\n  cursor: pointer;\n}\r\n", ""]);
// Exports
module.exports = exports;
